module.exports = __webpack_public_path__ + "static/media/arrow_icon.f26dc3a9.svg";